import { Inline } from '../../../../design-system/inline/inline';

type CardDetailsRowProps = {
  label: string;
  value: string;
  multiline?: boolean;
};

export const CardDetailsRow = ({ label, value, multiline = false }: CardDetailsRowProps) => (
  <Inline align={multiline ? 'start' : 'center'} justify="between" space={4} className="w-full">
    <span className="shrink-0 text-sm text-muted-foreground">{label}</span>
    <span className={`text-sm text-foreground ${multiline ? 'max-w-[160px] text-right' : ''}`}>{value}</span>
  </Inline>
);
